import { motion } from "framer-motion";
import { SiGmail, SiLinkedin, SiMedium, SiStackoverflow } from "react-icons/si";
import styled from "styled-components";

const Container = styled(motion.div)`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Text = styled(motion.span)`
  font-size: 4rem;
  font-weight: 700;
  color: #ffffff;

  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
`;

const LinkContainer = styled(motion.div)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 5rem;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 80%;
  }
`;

const Icon = styled(motion.a)`
  font-size: 5rem;
  :visited {
    text-decoration: none;
  }

  @media screen and (max-width: 768px) {
    font-size: 2rem;
  }
`;

const iconStyle = {
  // size: "5rem",
  color: "#ffffff",
  cursor: "pointer",
};

const iconVariants = {
  hidden: { opacity: 0, scale: 0 },
  visible: { opacity: 1, scale: 1 },
};

const App = () => {
  const nameDuration = 0.2;
  const iconDuration = 0.3;

  return (
    <Container>
      <Text
        initial={{ scale: 0.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: nameDuration }}
      >
        Piyush Satija
      </Text>
      <LinkContainer>
        <Icon
          href="mailto:piyush.satija@gmail.com"
          initial="hidden"
          variants={iconVariants}
          animate="visible"
          transition={{ duration: iconDuration, delay: nameDuration }}
        >
          <SiGmail {...iconStyle} />
        </Icon>
        <Icon
          href="https://www.linkedin.com/in/piyushsatija/"
          target="_blank"
          rel="noopener noreferrer"
          initial="hidden"
          variants={iconVariants}
          animate="visible"
          transition={{ duration: iconDuration, delay: nameDuration + 0.1 }}
        >
          <SiLinkedin {...iconStyle} />
        </Icon>
        <Icon
          href="https://medium.com/@piyush.satija"
          target="_blank"
          rel="noopener noreferrer"
          initial="hidden"
          variants={iconVariants}
          animate="visible"
          transition={{ duration: iconDuration, delay: nameDuration + 0.2 }}
        >
          <SiMedium {...iconStyle} />
        </Icon>
        <Icon
          href="https://stackoverflow.com/users/11203680/piyush-satija"
          target="_blank"
          rel="noopener noreferrer"
          initial="hidden"
          variants={iconVariants}
          animate="visible"
          whileHover={{ color: "pink" }}
          transition={{ duration: iconDuration, delay: nameDuration + 0.3 }}
        >
          <SiStackoverflow {...iconStyle} />
        </Icon>
      </LinkContainer>
    </Container>
  );
};

export default App;
